import {
  MAIN_URL,
  PORT_FOR_AUTH,
  API_AUTHORIZATION_LOGIN,
  API_FIRST_LOGIN,
} from "../../constants/constants";
import {
  AUTHORIZATION_LOGIN_FAILURE,
  AUTHORIZATION_LOGIN_SUCCESS,
  FIRST_LOGIN_FAILURE,
  FIRST_LOGIN_SUCCESS,
  SET_LOGIN_STATUS,
} from "../types";
import Cookies from "js-cookie";

export const loginByLoginPassword = (params) => {
  return async (dispatch) => {
    if (!navigator.onLine) {
      dispatch({
        type: AUTHORIZATION_LOGIN_FAILURE,
        data: "Отсутствует подключение к Интернету",
      });
      return;
    }

    const response = await fetch(
      MAIN_URL + PORT_FOR_AUTH + API_AUTHORIZATION_LOGIN,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params),
      },
    ).catch((err) => console.error(err));

    if (response.ok) {
      const data = await response.json();

      const currentTime = new Date();
      const accessTokenTime = new Date(currentTime.getTime() + 4 * 60 * 1000);
      const refreshTokenTime = new Date(
        currentTime.getTime() + 1440 * 60 * 1000,
      );

      Cookies.set("refreshToken", data.refreshToken, {
        expires: refreshTokenTime,
      });
      Cookies.set("accessToken", data.accessToken, {
        expires: accessTokenTime,
      });
      Cookies.set("userId", data.id, { expires: 50 });
      Cookies.set("isAuthorized", data.isAuthorized, { expires: 2 });

      dispatch({
        type: AUTHORIZATION_LOGIN_SUCCESS,
        data: data,
      });
    }

    if (!response.ok) {
      const data = await response.text();
      dispatch({
        type: AUTHORIZATION_LOGIN_FAILURE,
        data: data,
      });
    }
  };
};

export const setLoginStatus = (isLogin) => {
  return {
    type: SET_LOGIN_STATUS,
    payload: isLogin,
  };
};

export const loginFirstLogin = (params) => {
  return async (dispatch) => {
    const response = await fetch(MAIN_URL + PORT_FOR_AUTH + API_FIRST_LOGIN, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(params),
    });

    if (response.ok) {
      Cookies.set("isAuthorized", "false", {
        expires: 7,
      });

      const data = await response.text();
      dispatch({
        type: FIRST_LOGIN_SUCCESS,
        data: data,
      });
    }

    if (!response.ok) {
      const data = await response.text();
      dispatch({
        type: FIRST_LOGIN_FAILURE,
        data: data,
      });
    }
  };
};
